<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M86.2 50.7l-44 44-9.9-9.9 34.1-34.1-34.7-34.8L41.6 6z"/><!-- Created by Renee Ramsey-Passmore from the Noun Project--></svg>
